var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('img',{staticStyle:{"width":"200px","height":"auto"},attrs:{"src":require("@assets/img/404@3x.png"),"alt":""}}),_c('h4',{staticStyle:{"margin":"12px 0 40px 0"}},[_vm._v("\n    很抱歉，没有找到您要访问的页面！\n  ")])])
}]

export { render, staticRenderFns }